// To focus element based on ID
window.focusElement = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.focus();
    }
}

// To Download a file
window.saveAsFile = (filename, bytesBase64) => {
    var link = document.createElement('a');
    link.download = filename;
    link.href = 'data:application/octet-stream;base64,' + bytesBase64;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

window.downloadFile = function (filename, content) {
    const link = document.createElement('a');
    const fileExtension = filename.split('.').pop().toLowerCase();

    let mimeType = 'application/octet-stream'; // Default to binary stream type
    if (fileExtension === 'pptx') {
        mimeType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
    } else if (fileExtension === 'pdf') {
        mimeType = 'application/pdf';
    } else if (fileExtension === 'txt') {
        mimeType = 'text/plain';
    } else if (fileExtension === 'jpg' || fileExtension === 'jpeg') {
        mimeType = 'image/jpeg';
    } else if (fileExtension === 'png') {
        mimeType = 'image/png';
    }
    link.href = `data:${mimeType};base64,` + content;

    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

// To Open Save As Dialog
window.triggerSaveAsDialog = function () {
    const link = document.createElement('a');
    link.href = 'data:application/octet-stream,';
    link.download = 'exported_certificate.txt'; // Default filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

// To Trigger input click
window.triggerFileInputClick = function (inputId) {
    document.getElementById(inputId).click();
}

window.getDeviceInfo = function () {
    const userAgent = navigator.userAgent;
    const OsVersion = navigator.oscpu || navigator.appVersion;

    // Extract Browser Name and Version
    let BrowserName = "Unknown Browser";
    let BrowserVersion = "Unknown Version";
    if (userAgent.indexOf("Chrome") > -1) {
        BrowserName = "Chrome";
        BrowserVersion = userAgent.split("Chrome/")[1].split(" ")[0];
    } else if (userAgent.indexOf("Safari") > -1) {
        BrowserName = "Safari";
        BrowserVersion = userAgent.split("Version/")[1].split(" ")[0];
    } else if (userAgent.indexOf("Firefox") > -1) {
        BrowserName = "Firefox";
        BrowserVersion = userAgent.split("Firefox/")[1];
    } else if (userAgent.indexOf("Edge") > -1) {
        BrowserName = "Edge";
        BrowserVersion = userAgent.split("Edg/")[1];
    }

    // Detect Device Type (Mobile, Tablet, Desktop)
    const DeviceType = /Mobi|Android|Touch/.test(userAgent) ? 'Mobile' :
        /Tablet/.test(userAgent) ? 'Tablet' : 'Desktop';

    // Device Model is generally not exposed, but we can attempt to extract it from the user agent string.
    const DeviceModel = navigator.vendor || "Unknown Device";

    // Detect OS Name and Version (Basic)
    let OsName = "Unknown OS";
    if (userAgent.indexOf("Windows NT") > -1) OsName = "Windows";
    else if (userAgent.indexOf("Mac OS X") > -1) OsName = "MacOS";
    else if (userAgent.indexOf("Android") > -1) OsName = "Android";
    else if (userAgent.indexOf("iPhone") > -1 || userAgent.indexOf("iPad") > -1) OsName = "iOS";
    else if (userAgent.indexOf("Linux") > -1) OsName = "Linux";

    return {
        Ip: "Not Available in JS", // IP requires a server-side solution
        BrowserName,
        BrowserVersion,
        DeviceType,
        DeviceModel,
        OsName,
        OsVersion
    };
}

// === TO TOGGLE FULLSCREEN MODE ===
window.requestFullscreen = function () {
    const elem = document.documentElement;
    if (elem.requestFullscreen) {
        elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) { // Safari
        elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { // IE/Edge
        elem.msRequestFullscreen();
    }
};

window.exitFullscreen = function () {
    if (typeof document !== 'undefined') {
        if (document?.exitFullscreen) {
            document.exitFullscreen();
        } else if (document?.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document?.msExitFullscreen) {
            document.msExitFullscreen();
        }
    }
};
// ====== //

// === Copy to Clipboard ===
window.copyToClipboard = function (text) {
    if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text)
            .then(() => {
                console.log("Copied to clipboard");
            })
            .catch(err => {
                console.error("Failed to copy: ", err);
            });
    } else {
        let textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        textArea.style.left = "-99999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            document.execCommand('copy');
            console.log("Copied to clipboard");
        } catch (err) {
            console.error("Fallback: Oops, unable to copy", err);
        }
        document.body.removeChild(textArea);
    }
}
window._notificationScroll = window._notificationScroll || {};

window.registerScroll = (elementId, dotNetObjRef) => {
    const el = document.getElementById(elementId);
    if (!el) {
        console.log("Element not found:", elementId);
        return;
    }

    if (window._notificationScroll[elementId]?.registered) return;

    let isLoadingNextPage = false;
    let atTopHandled = false;
    let scrollTimeout;

    const handler = async () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(async () => {
            const scrollTop = el.scrollTop;
            const scrollHeight = el.scrollHeight;
            const clientHeight = el.clientHeight;

            const atBottom = scrollTop + clientHeight >= scrollHeight - 5;
            const atTop = scrollTop <= 5;

            if (atBottom && !isLoadingNextPage) {
                isLoadingNextPage = true;
                try {
                    await dotNetObjRef.invokeMethodAsync('LoadNextPage');
                } catch (err) {
                    console.error(err);
                } finally {
                    setTimeout(() => { isLoadingNextPage = false; }, 300);
                }
            }

            if (atTop && !atTopHandled) {
                atTopHandled = true;
                try {
                    await dotNetObjRef.invokeMethodAsync('ScrollPositionChanged', scrollTop, atTop);
                } catch (err) {
                    console.error(err);
                }
            } else if (!atTop) {
                atTopHandled = false;
            }
        }, 150);
    };

    el.addEventListener('scroll', handler);

    window._notificationScroll[elementId] = {
        handler,
        registered: true
    };
};

window.unregisterScroll = (elementId) => {
    const el = document.getElementById(elementId);
    const record = window._notificationScroll[elementId];

    if (el && record?.handler) {
        el.removeEventListener('scroll', record.handler);
    }

    delete window._notificationScroll[elementId];
};

window.scrollToTop = (elementId) => {
    const el = document.getElementById(elementId);
    if (el) {
        el.scrollTop = 0;
    }
};
